import { useCallback, useEffect, useRef, useState } from 'react'

/** Runs a retry one at a time and says while it runs, so a double click sends it once */
const useRetry = (run: () => Promise<unknown>) => {
  const [isRetrying, setIsRetrying] = useState(false)
  const inFlight = useRef(false)
  const mounted = useRef(true)
  useEffect(
    () => () => {
      mounted.current = false
    },
    []
  )

  const retry = useCallback(async () => {
    if (inFlight.current) return
    inFlight.current = true
    setIsRetrying(true)
    try {
      await run()
    } finally {
      inFlight.current = false
      if (mounted.current) setIsRetrying(false)
    }
  }, [run])

  return { retry, isRetrying }
}

export default useRetry
